import { PureComponent } from 'react';
import { Treemap, ResponsiveContainer } from 'recharts';

const getEarthyBlueShade = () => {
  const hue = Math.floor(Math.random() * 30) + 190; // Keeps it in the blue-green spectrum
  const saturation = Math.floor(Math.random() * 30) + 30; // Soft, muted saturation for an earthy feel
  const lightness = Math.floor(Math.random() * 25) + 25; // Richer tones without being too bright

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

const colors = ["#4C6B8A", "#5F8D4E", "#2A4D69", "#3F5E5A", "#3C91E6", "#76B041", "#3F5E5A", "#D9A673", "#B4C49A", "#C9B1BD", "#E2CFC3", "#CABFAB", "#D1BBA8", "#B9C3B0", "#C5B9A0", "#9DA9A0", "#C5B9A0", "#9DA9A0", "#C2B280"]

interface CustomContentProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  litres?: number;
  color?: string;
  name?: string;
}

const CustomizedContent: React.FC<CustomContentProps> = ({ x, y, width, height, litres, color, name }) => {
  return (
    <g>
      <rect x={x} y={y} width={width} height={height} fill={color} stroke="#fff" />
      <text
        x={x + width / 2}
        y={y + height / 2 - 10}
        fontSize={12}
        letterSpacing={1.5}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {name}
      </text>
      <text
        x={x + width / 2}
        y={y + height / 2 + 10}
        fontSize={12}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {litres} l
      </text>
    </g>
  );
};

const formatDataByBidder = (data) => {
  const typeValues = data.reduce((acc, { bidder, amount }) => {
    acc[bidder] = (acc[bidder] || 0) + amount; // Summing amounts by bidder
    return acc;
  }, {});

  let colorIndex = 0;

  const getNextColor = () => {
    return colorIndex < colors.length ? colors[colorIndex++] : getEarthyBlueShade();
  };

  return Object.keys(typeValues).map((bidder) => ({
    name: bidder,
    litres: parseFloat(typeValues[bidder].toFixed(3)),
    color: getNextColor()
  }));
};

interface Props {
  data: any;
}
export default class TreeMapBidders extends PureComponent<Props> {

  render() {
    const { data } = this.props;
    const formattedResults = formatDataByBidder(data);

    return (
      <ResponsiveContainer width="100%" height={300}>
        <Treemap
          width={300}
          height={300}
          data={formattedResults}
          dataKey="litres"
          aspectRatio={4 / 3}
          stroke="#fff"
          content={<CustomizedContent />}
        />
      </ResponsiveContainer>
    );
  }
}